import { DecimalPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  inject,
  input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { merge, Subject, takeUntil } from 'rxjs';
import { ArchiveService } from '../../../services/archive.service';
import { ProgressToastArchive } from '../../../services/progress-toast.service';
import { ButtonDirective } from '../../directives/button.directive';
import { DataUnitsBigIntPipe } from '../../pipes/data-units-big-int.pipe';
import { CircleProgressBarComponent } from '../circle-progress-bar/circle-progress-bar.component';
import { AnimatedSvgComponent } from '../svg/animated-svg.component';
import { SvgComponent } from '../svg/svg.component';

@Component({
  selector: 'app-progress-archive-toasts-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CircleProgressBarComponent,
    DataUnitsBigIntPipe,
    DecimalPipe,
    SvgComponent,
    ButtonDirective,
    AnimatedSvgComponent,
  ],
  templateUrl: './progress-archive-toasts-item.component.html',
  styleUrl: './progress-archive-toasts-item.component.scss',
})
export class ProgressArchiveToastsItemComponent implements OnInit, OnDestroy {
  public archiveService = inject(ArchiveService);
  private check = inject(ChangeDetectorRef);
  toast = input<ProgressToastArchive>();
  toastItem = computed(() => {
    const allItems = this.archiveService.items();
    return allItems.find(item => item.key === this.toast().id);
  });
  destroyed$ = new Subject<void>();

  ngOnInit(): void {
    merge(
      this.archiveService.onArchiveProgress$,
      this.archiveService.onArchiveCancelled$,
      this.archiveService.onArchiveFinalized$,
      this.archiveService.onArchiveFailed$
    )
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.check.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
